module.exports = __webpack_public_path__ + "img/disruptive-behavior.c06b084e.svg";